
import { combineReducers } from 'redux';

import operationStatus from '../common/client/reducers/operationStatus';

import map from './map';
import project from './project';

export default combineReducers({
    map,
    operationStatus,
    project: project()
});
